import Joi from 'joi';

export const PscSchema = Joi.object({
  dateFrom: Joi.date().required(),
  dateTo: Joi.date().min(Joi.ref('dateFrom')).required(),
});
